import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";
import {DashboardMenuModel} from "../../models/dashboard/dashboard.model";

@Injectable()
export class SidebarService {

  private subjectClose = new Subject();
  private subjectToggle = new Subject();
  menuData: DashboardMenuModel;

  close$ = this.subjectClose.asObservable();
  toggle$ = this.subjectToggle.asObservable();

  toggleSidebar() {
    // this.collapsedSidebar = !this.collapsedSidebar;
    this.subjectToggle.next();
  }

  turnOfSiderbar() {
    this.subjectClose.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/sidebar.service.ts